import { render, staticRenderFns } from "./NavigationStandingsIconParts.vue?vue&type=template&id=2c484272"
import script from "./NavigationStandingsIconParts.vue?vue&type=script&lang=ts"
export * from "./NavigationStandingsIconParts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports